import { http } from '../../jobs/api/http';

// endpoint: /api/redis/physical-tokens
// includePlanned: also return PLANNED-but-not-yet-produced tokens (for "Plan ahead")
export async function fetchBobinsState(includePlanned = false) {
  const res = await http.get(
    '/api/redis/physical-tokens' + (includePlanned ? '?includePlanned=true' : '')
  );
  // backend return: { success, count, jobs }
  return res.data;
}
